import { SafeAny } from '@project-hub/types';
import type { OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';

export interface BaseResult<TData extends Record<string, SafeAny>> {
  data?: TData | null;
}

export function queryData<TResult extends BaseResult<SafeAny>, TData extends NonNullable<TResult['data']>, TQuery extends keyof TData>(
  query: TQuery,
): OperatorFunction<TResult, TData[TQuery]> {
  return map((queryResult) => {
    return queryResult.data[query];
  });
}
